import { useLocale } from 'next-intl'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'
import { Link as LinkComponent } from '@repo/web-ui/components/link'

export function Link({
  href,
  children,
  addLocaleToPath = true,
  ...rest
}: {
  addLocaleToPath?: boolean
  href: string
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  dangerouslySetInnerHTML?: { __html: string }
}) {
  const locale = useLocale()
  const hrefWithLocale = addLocaleToPath ? addOrReplaceLocaleInUrl(href, locale) : href

  return (
    <LinkComponent href={hrefWithLocale} {...rest}>
      {children ? children : null}
    </LinkComponent>
  )
}
